import React, { useState } from 'react';
import classNames from 'classnames';
import styles from './Items.module.css';
import { searchIcon } from '../../../../../assets/images';
import Toggle from '../../../../../components/Toggle';
import Checkbox from '../../../../../components/Checkbox';
import strings from '../../../../../globalization';

export default function OutOfStockItems(props) {
  const {
    searchOutOfStockItems,
    popup,
    getOutOfStock,
    outOfStockItems,
    outOfStockMode,
    updateItemStock,
    outOfStockSearchList,
    onClose,
    includeUnavailable,
    toggleIncludeUnavailable,
  } = props;
  const [fieldValue, setFieldValue] = useState('');
  const [sortByName, setSortByName] = useState(true);

  const search = () => {
    if (fieldValue.length === 0) return;
    searchOutOfStockItems && searchOutOfStockItems(popup.type, fieldValue);
    setFieldValue('');
  }

  const onItemClick = item => {
    updateItemStock && updateItemStock(item, popup.type);
  }

  const onSubmit = e => {
    e.preventDefault();
    search();
  };

  const onChangeSortByName = () => {
    setSortByName(prevSortByName => !prevSortByName);
  };

  const pad = (value) => {
    let str = String(value);
    let size = 10;
    while (size > 0) {
      str = '0' + str;
      size--;
    }
    return str;
  };

  const sortNameFunc = (a, b) => {
    const name1 = pad(a.name ? a.name : '').toLowerCase();
    const name2 = pad(b.name ? b.name : '').toLowerCase();
    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }
    return 0;
  };

  const sortPOSIDFunc = (a, b) => {
    const posId1 = pad(a.posId ? a.posId : '').toLowerCase();
    const posId2 = pad(b.posId ? b.posId : '').toLowerCase();
    if (posId1 < posId2) {
      return -1;
    }
    if (posId1 > posId2) {
      return 1;
    }
    return 0;
  };

  const searchedItemsList = sortByName
    ? outOfStockSearchList.sort(sortNameFunc)
    : outOfStockSearchList.sort(sortPOSIDFunc);

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.leftWrapper}>
        <div className={styles.leftHeader}>{strings.outOfStock.toUpperCase()}</div>
        <div className={styles.leftItems}>
          {outOfStockItems.map((item) => {
            return <Item key={`leftItem-${item.id}`} item={item} onClick={() => onItemClick(item)} />
          })}
          <button className={styles.reloadBtn} onClick={() => getOutOfStock(outOfStockMode)}>{strings.reloadOutOfStock.toUpperCase()}</button>
        </div>
      </div>
      <div className={styles.rightWrapper}>
        <div className={styles.closePopupBtn} onClick={onClose}>X</div>
        <div className={styles.wrapper}>
          <div className={styles.flexRow}>
            <SearchInput
              value={fieldValue}
              onChange={val => setFieldValue(val)}
              onSubmit={onSubmit}
              search={search}
            />
            <CheckBox checked={includeUnavailable} onChange={toggleIncludeUnavailable} />
          </div>
          <Switch selected={sortByName} onToggle={onChangeSortByName} />
        </div>
        <div className={styles.container}>
          {searchedItemsList.map(item => {
            const isOutOfStock = outOfStockItems.find(i => i.id === item.id);
            const name = item.posId ? `${item.name} (${item.posId})` : item.name;
            return (
              <div
                key={`searchItem-${item.id}`}
                className={classNames({ [styles.cell]: true, [styles.unavailableItem]: !item.available })}
                onClick={() => onItemClick(item)}>
                <div className={[styles.items, isOutOfStock ? styles.stockWidth : styles.inStockWidth].join(' ')}>{name}</div>
                {isOutOfStock ? <span className={styles.outOfStockRep}>86</span> : null}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};

const Item = (props) => {
  const { item, onClick } = props;
  const name = item.posId ? `${item.name} (${item.posId})` : item.name;
  return (
    <div className={styles.leftItem} onClick={onClick}>
      {name}
      <span className={styles.outOfStockRep}>86</span>
    </div>
  );
};

const SearchInput = ({ value, onChange, onSubmit, search }) => {
  return (
    <div className={styles.searchWrapper}>
      <form onSubmit={onSubmit}>
        <input
          type="text"
          value={value}
          placeholder={strings.searchWithPosIdOrName}
          onChange={event => onChange(event.target.value)}
          className={styles.textInput} />
      </form>
      <img src={searchIcon} alt="search" className={styles.searchIcon} onClick={search} />
    </div>
  );
};

const Switch = ({ onToggle, selected }) => {
  return (
    <div className={styles.switchWrapper}>
      <span className={styles.switchName}>{strings.sortByName}</span>
      <Toggle onClick={onToggle} selected={selected} />
      <span className={styles.switchName}>{strings.sortByPOSID}</span>
    </div>
  );
};

const CheckBox = ({ checked, onChange }) => {
  return (
    <div className={styles.checkboxWrapper}>
      <Checkbox checked={checked} onChange={onChange} />
      <span className={styles.switchName}>{strings.includeUnavailable}</span>
    </div>
  );
};
